module.exports = __webpack_public_path__ + "img/Left_one.4ff2ff4b.svg";